import { TimelineLite, Power2 } from 'gsap'
import bus from './bus'
import UI from './utils/UI'

UI({
  component: '.js-productIntro',
  items: ['.js-productIntro-item']
}, ({ component, items }) => {
  if (!component.length) {
    bus.on('single-product-ready', _ => tl.resume())
  }

  const tl = new TimelineLite({ onComplete: _ => bus.emit('product-intro-ready'), paused: true })

  items.forEach(item => {
    if (item.offsetHeight) {
      tl.to(item, 0.5, {
        opacity: 1,
        ease: Power2.easeInOut
      }, '-=0.35')
    } else {
      item.style.opacity = 1
    }
  })

  bus.on('single-product-ready', _ => tl.resume())
})
